import { Type } from "class-transformer";
import { ProjectCustomFieldDefinition } from "./ProjectCustomFieldDefinition";
import { ProjectTemplate } from "./ProjectTemplate";

export class ProjectTemplateField {
    fieldDefinitionId = 0;
    @Type(() => ProjectCustomFieldDefinition)
    fieldDefinition: ProjectCustomFieldDefinition;
    value: string;
    templateId = 0;
    @Type(() => ProjectTemplate)
    template: ProjectTemplate;
    id = 0;
}
